<template>
  <v-container>
    <v-layout justify-center class="ma-0 mt-4">
      <v-card flat class="pl-3 pr-3" width="900">
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-flex md12 xs12>
              <v-text-field
                label="Título"
                v-model="body.titulo"
                required
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex md12 xs12>
              <v-select
                v-model="body.idTurmas"
                :items="turmas"
                label="Turma"
                :item-text="
                  turma =>
                    `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                "
                multiple
                chips
                item-value="id"
                hint="Seleciona a(s) Turma(s)"
                persistent-hint
                clearable
                required
                :rules="rules"
              ></v-select>
            </v-flex>
            <v-flex md6 xs12>
              <v-radio-group row v-model="body.desativar">
                <header class="mr-4">Ativo:</header>
                <v-radio
                  v-for="(option, index) in radioOptions"
                  :key="option"
                  color="primary"
                  :label="option"
                  :value="index == 0 ? 'N' : 'S'"
                />
              </v-radio-group>
            </v-flex>
            <v-flex md6 xs12>
              <v-layout>
                <v-flex md6 class="mr-3">
                  <v-select
                    v-model="dia"
                    :items="dias"
                    label="Dia"
                    item-text="texto"
                    :item-value="item => `${item.id}/${item.texto}`"
                    hint="Seleciona um dia da semana"
                    persistent-hint
                    clearable
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>
                <v-flex md6>
                  <v-select
                    v-model="cardapio_item_tipo"
                    :items="tipos"
                    item-text="nome"
                    :item-value="item => `${item.id}/${item.nome}`"
                    label="Tipo"
                    hint="Seleciona um tipo de refeição"
                    persistent-hint
                    clearable
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-select
                v-model="cardapio_item_produto"
                :items="produtos"
                item-text="nome"
                :item-value="item => item.id"
                label="Produto"
                hint="Seleciona os produtos para a refeição"
                persistent-hint
                multiple
                chips
                clearable
              ></v-select>
            </v-flex>
            <v-flex md12 xs12>
              <v-textarea
                v-model="conteudo"
                name="input-5-1"
                label="Conteúdo"
                hint="Descreva o que vai ser o cardápio"
                required
                :rules="rules"
              ></v-textarea>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-flex md12 xs12>
              <v-btn
                elevation="0"
                color="primary"
                style="float: left"
                small
                dark
                @click="add"
                >Adicionar</v-btn
              >
            </v-flex>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-layout>
    <v-layout justify-center class="mt-3">
      <v-card flat width="900">
        <v-card-text>
          <p class="title primary--text">
            <v-icon color="primary" left>mdi-calendar-clock</v-icon>
            <span>Itens adicionados</span>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">ID</th>
                    <th class="text-left">Dia</th>
                    <th class="text-left">Tipo</th>
                    <th class="text-left">Conteúdo</th>
                    <th class="text-left">Produtos</th>
                    <th class="text-left">Excluír</th>
                  </tr>
                </thead>
                <tbody v-if="$route.params.id">
                  <tr v-for="(item, c) in body.cardapio_item" :key="c">
                    <td>{{ c + 1 }}</td>
                    <td v-if="item.dia == 1">Domingo</td>
                    <td v-if="item.dia == 2">Segunda</td>
                    <td v-if="item.dia == 3">Terça</td>
                    <td v-if="item.dia == 4">Quarta</td>
                    <td v-if="item.dia == 5">Quinta</td>
                    <td v-if="item.dia == 6">Sexta</td>
                    <td v-if="item.dia == 7">Sábado</td>

                    <td>{{ item.cardapio_item_tipo.nome }}</td>
                    <td>{{ item.conteudo }}</td>
                    <td>
                      <v-chip
                        v-for="produto in item.produto"
                        :key="produto.id"
                        small
                        class="mr-1 mb-1"
                      >{{ produto.nome }}</v-chip>
                    </td>
                    <td>
                      <v-btn
                        small
                        text
                        color="error"
                        @click="$refs.deletar.request(item.id)"
                      >
                        <v-icon lef>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(item, c) in items" :key="c">
                    <td>{{ c + 1 }}</td>
                    <td>{{ item.dia.split('/')[1] }}</td>
                    <td>{{ item.cardapio_item_tipo.split('/')[1] }}</td>
                    <td>{{ item.conteudo }}</td>
                    <td></td>
                    <td>
                      <v-btn small text color="error" @click="removerItem(c)">
                        <v-icon lef>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="$refs.salvar.request()" color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
    <confirm ref="salvar" :confirm-fn="submit">Deseja salvar agora?</confirm>
    <confirm ref="deletar" :confirm-fn="removerRefeicao"
      >Deseja apagar essa refeição?</confirm
    >
  </v-container>
</template>

<script>
import { Turma, Cardapio, Produto } from '../../service'
import Confirm from '../../components/Confirm'

export default {
  components: { Confirm },
  data() {
    return {
      valid: true,
      turmas: [],
      produtos: [],
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      dias: [
        { id: 1, texto: 'Domingo' },
        { id: 2, texto: 'Segunda' },
        { id: 3, texto: 'Terça' },
        { id: 4, texto: 'Quarta' },
        { id: 5, texto: 'Quinta' },
        { id: 6, texto: 'Sexta' },
        { id: 7, texto: 'Sábado' }
      ],
      tipos: [],

      body: {
        titulo: '',
        enviar: 0,
        idTurmas: null,
        desativar: 'N',
        itens: []
      },
      conteudo: '',
      dia: '',
      cardapio_item_tipo: '',
      cardapio_item_produto: '',
      items: [],
      rules: [v => !!v || 'Campo requerido.'],
      radioOptions: ['Sim', 'Não']
    }
  },
  async created() {
    await this.load()
  },
  watch: {
    cardapio_item_produto(ids) {
      if (!ids || ids.length === 0) return
      this.conteudo = ids
        .map(id => {
          const p = this.produtos.find(p => p.id === id)
          return p ? p.nome : ''
        })
        .filter(Boolean)
        .join(', ')
    }
  },
  methods: {
    async add() {
      if (this.$refs.form.validate() && this.$route.params.id) {
        try {
          await Cardapio.addItem(
            {
              dia: parseInt(this.dia, 10),
              cardapio_item_tipo_id: parseInt(
                this.cardapio_item_tipo.split('/')[0]
              ),
              idsProdutos: this.cardapio_item_produto,
              conteudo: this.conteudo,
              cardapio_id: this.$route.params.id
            },
            { escola: this.escola }
          )

          await this.getDadosPorId()
        } catch (erro) {
          //console.log(erro)
        }
      } else if (this.$refs.form.validate()) {
        this.items.push({
          dia: this.dia,
          cardapio_item_tipo: this.cardapio_item_tipo,
          cardapio_item_produto: this.cardapio_item_produto,
          conteudo: this.conteudo
        })
      }
    },
    async submit() {
      if (this.$route.params.id) {
        await Cardapio.update(
          { ...this.body, id: this.$route.params.id },
          { escola: this.escola }
        )
        this.$router.push(`/refeicoes/${this.$route.params.id}`)
        return
      }

      if (this.items.length > 0) {
        this.body.itens = this.items.map(item => ({
          ...item,
          cardapio_item_tipo_id: parseInt(
            item.cardapio_item_tipo.split('/')[0]
          ),
          idsProdutos: item.cardapio_item_produto,
          dia: parseInt(item.dia.split('/')[0])
        }))

        const res = await Cardapio.save(this.body, { escola: this.escola })
        this.$router.push(`/refeicoes/${res.id}`)
      }
    },
    async removerRefeicao(item) {
      try {
        await Cardapio.deletarItem(item, {
          escola: this.escola
        })
        await this.getDadosPorId()
      } catch (error) {
        //console.log(error)
      }
    },
    removerItem(item) {
      //console.log(this.items.indexOf(item))
      this.items.splice(item, 1)
    },
    async load() {
      this.turmas = await Turma.findAll({ escola: this.escola })
      this.tipos = await Cardapio.getTipos({ escola: this.escola })
      this.produtos = await Produto.filterLanche({ escola: this.escola })

      if (this.$route.params.id) {
        const body = await Cardapio.findByIdProduto(this.$route.params.id, {
          escola: this.escola
        })

        this.body = body
        this.body.idTurmas = body.turma.map(t => t.id)
        this.body.cardapio_item = body.cardapio_item.slice().sort((a, b) => a.dia - b.dia)
      }
    },
    async getDadosPorId() {
      if (this.$route.params.id) {
        const body = await Cardapio.findByIdProduto(this.$route.params.id, {
          escola: this.escola
        })

        this.body = body
        this.body.idTurmas = body.turma.map(t => t.id)
        this.body.cardapio_item = body.cardapio_item.slice().sort((a, b) => a.dia - b.dia)
      }
    }
  }
}
</script>

<style></style>
